import React, { useState, useEffect } from 'react';
import { ChartAnimationsContext } from './chartAnimationsTypes';

const STORAGE_KEY = 'chart-animations-enabled';

export const ChartAnimationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [chartAnimationsEnabled, setChartAnimationsEnabled] = useState<boolean>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === null) return true; // default: animations on
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(chartAnimationsEnabled));
  }, [chartAnimationsEnabled]);

  const toggleChartAnimations = () => {
    setChartAnimationsEnabled((prev) => !prev);
  };

  return (
    <ChartAnimationsContext.Provider value={{ chartAnimationsEnabled, toggleChartAnimations }}>
      {children}
    </ChartAnimationsContext.Provider>
  );
};
